import produce from 'immer'
import create from 'zustand'

import FakturaTicketFlow from '@faktura-art/acs-ethereum'
import { IContract, ICoupon, IEndPoint, IProviderInit, TPaymentMethods, TValidSteps } from '@types'

interface IMainProperties {
    shouldWarning: boolean
    warningMessage: string
    currentWallet: string
    transactionHash: string
    mainInit: IProviderInit
    contract: IContract
    selectedSalesBehaviour: IEndPoint
    currentStep: TValidSteps
    coupon: ICoupon
    isLoading: boolean
    errorMessage: string
}

export interface IMainPropertiesData {
    shouldWarning: IMainProperties['shouldWarning']
    warningMessage: IMainProperties['warningMessage']
    currentWallet: IMainProperties['currentWallet']
    transactionHash: IMainProperties['transactionHash']
    currentStep: IMainProperties['currentStep']
    selectedSalesBehaviour: IMainProperties['selectedSalesBehaviour']
    contract: IContract
    mainInit: IProviderInit
    coupon: ICoupon
    isLoading: boolean
    errorMessage: string
    setCoupon: (value: ICoupon) => void
    setShouldWarning: (value: boolean) => void
    setWarningMessage: (value: string) => void
    setCurrentWallet: (value: string) => void
    setTransactionHash: (value: string) => void
    setMainInit: (value: IProviderInit) => void
    setContract: (value: IContract) => void
    setMainInitPaymentMethods: (value: TPaymentMethods) => void
    setCurrentSelectedEndpoint: (value: IEndPoint) => void
    setMainInitSalesBehaviourVisible: (value: IEndPoint[]) => void
    setCurrentStep: (value: IMainProperties['currentStep']) => void
    setContractSalesPhase: (value: number) => void
    setIsLoading: (value: boolean) => void
    setErrorMessage: (value: string) => void
    reset: () => void
}

const initialState: IMainProperties = {
    shouldWarning: false,
    warningMessage: '',
    currentWallet: '',
    transactionHash: '',
    contract: FakturaTicketFlow as unknown as IContract,
    mainInit: {} as IProviderInit,
    currentStep: 'home',
    selectedSalesBehaviour: {} as IEndPoint,
    isLoading: true,
    errorMessage: '',
    coupon: {
        r: '0x0',
        s: '0x0',
        v: 0,
        createdAt: '',
        address: '',
        sales: 0,
        collectionId: '',
    },
}
const useStoreMain = create<IMainPropertiesData>(set => ({
    ...initialState,
    setShouldWarning: value => set(() => ({ shouldWarning: value })),
    setWarningMessage: value => set(() => ({ warningMessage: value })),
    setCurrentWallet: value => set(() => ({ currentWallet: value })),
    setTransactionHash: value => set(() => ({ transactionHash: value })),
    setMainInit: value => set(() => ({ mainInit: value })),
    setIsLoading: value => set(() => ({ isLoading: value })),
    setErrorMessage: value => set(() => ({ errorMessage: value })),
    setMainInitPaymentMethods: value =>
        set(
            produce(state => {
                state.mainInit.paymentMethods = value
            }),
        ),
    setContractSalesPhase: value =>
        set(
            produce(state => {
                state.contract.salesPhase = value
            }),
        ),
    setMainInitSalesBehaviourVisible: value =>
        set(
            produce(state => {
                state.mainInit.salesBehavior = value
            }),
        ),
    setCurrentSelectedEndpoint: value =>
        set(
            produce(state => {
                state.selectedSalesBehaviour = value
            }),
        ),
    setContract: value => set(() => ({ contract: value })),
    setCurrentStep: value => set(() => ({ currentStep: value })),
    setCoupon: value => set(() => ({ coupon: value })),
    reset: () => {
        set(produce(state => ({ ...initialState, path: state.path })))
    },
}))

export default useStoreMain
